const MS_PER_DAY = 86_400_000;
const MS_PER_SECOND = 1000;

export const NEW_ARRIVALS_WINDOW_DAYS = 90;

/** Numeric unix-seconds attribute on `products_jb4`. Keep string `golive_date` for sort. */
export const ALGOLIA_GO_LIVE_DATE_UNIX_FIELD = 'go_live_date_unix';

const getUtcDayStartMs = (ms = Date.now()) =>
  Math.floor(ms / MS_PER_DAY) * MS_PER_DAY;

/**
 * UTC midnight of (now − 90 days), as unix seconds.
 *
 * InstantSearchNext SSR keys off Configure params. A cutoff based on
 * `Date.now()` would change every request and defeat `'use cache'`. Rounding
 * to the UTC day keeps the key stable for 24 hours (CON-8566).
 *
 * Backend contract: number, unix seconds (not ms, not `"YYYY-MM-DD"`).
 * `"2026-06-29"` → `1782691200`. Index as `filterOnly(go_live_date_unix)`.
 */
export const getNewArrivalsGoliveDateCutoffUnixSeconds = (nowMs = Date.now()) =>
  getUtcDayStartMs(nowMs - NEW_ARRIVALS_WINDOW_DAYS * MS_PER_DAY) /
  MS_PER_SECOND;

export const buildNewArrivalsGoliveDateNumericFilter = (nowMs = Date.now()) =>
  `${ALGOLIA_GO_LIVE_DATE_UNIX_FIELD}>=${getNewArrivalsGoliveDateCutoffUnixSeconds(
    nowMs
  )}`;
